import { Form, TextArea } from "simplydo/react/ui";

import { MultiLineParagraph } from "components/lib/UI";

import { FieldProps } from "./FieldProps";

const LongText = ({
  field,
  fieldValue = "",
  updateIdea,
  isEditing,
}: FieldProps) => {
  const textValue = typeof fieldValue === "string" ? fieldValue : "";
  if (!isEditing) return <MultiLineParagraph content={textValue} />;
  return (
    <Form>
      <TextArea
        value={textValue}
        onChange={(_e, { value }) =>
          updateIdea(String(value ?? ""), ["templated", field.id])
        }
      />
    </Form>
  );
};

export default LongText;
